import { Activity, Network, Route } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { PillLink } from "@/components/common/PillLink";

const METHODS = [
  { title: "Continuous Assessment", icon: Activity, color: "bg-mint",
    text: "We track each student's learning performance over time, not just the result of a single test." },
  { title: "Personalised Knowledge Map", icon: Network, color: "bg-sky",
    text: "Each student's knowledge map is built and updated step by step, based on evidence of their learning." },
  { title: "Adaptive Learning Pathways", icon: Route, color: "bg-lavender",
    text: "Personalised learning suggestions based on what each student has mastered and how their abilities are developing." },
];

export const AssessmentSection = () => (
  <section className="section-y" aria-labelledby="assessment-title" data-testid="assessment-section">
    <div className="container-x">
      <SectionHeading id="assessment-title" eyebrow="Assessment" title="AI-Powered Assessment for Deeper Learning"
        intro="Through continuous AI-supported assessment, we track each student's progress, identify learning gaps, and build a personalised knowledge map over time—turning learning insights into meaningful next steps for individual growth." />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {METHODS.map(({ title, icon: Icon, color, text }, i) => (
          <Reveal key={title} delay={i * 0.08} as="article" className="h-full">
            <div className="card-soft h-full p-7" data-testid={`assessment-card-${i}`}>
              <span className={`grid h-12 w-12 place-items-center rounded-2xl ${color}`}><Icon className="h-6 w-6" aria-hidden="true" /></span>
              <h3 className="mt-5 text-xl font-semibold">{title}</h3>
              <p className="mt-3 text-ink-soft leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const BrandStatement = () => (
  <section className="container-x section-y" aria-label="Our promise" data-testid="brand-statement">
    <Reveal>
      <div className="rounded-[40px] bg-lavender px-7 py-16 text-center sm:px-14 sm:py-20">
        <p className="mx-auto max-w-4xl font-heading text-4xl font-semibold leading-tight tracking-tight sm:text-5xl">
          From Knowledge to Understanding.<br className="hidden sm:block" /> From Understanding to Action.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <PillLink to="/contact#enquire" variant="lemon" arrow data-testid="approach-enquire">Make an enquiry</PillLink>
          <PillLink to="/courses" variant="mint" arrow data-testid="approach-courses">Courses</PillLink>
        </div>
      </div>
    </Reveal>
  </section>
);
